import pro1 from "../assests/drdo.jpg";
import pro2 from "../assests/railways.jpg";
// import pro3 from "../assests/iith.jpg";
// import pro4 from "../assests/jntu.jpg";
// import pro5 from "../assests/matlab.jpg";
// import pro6 from "../assests/iit.jpg";
// import pro7 from "../assests/java.jpg";
// import pro8 from "../assests/ipr.jpg";
// import pro9 from "../assests/3d.jpg";
// import pro10 from "../assests/web.jpg";
// import pro12 from "../assests/chess.png";
// import pro13 from "../assests/food.png"
import pro14 from "../assests/saloon.png"
import pro15 from "../assests/grocery.png"
import pro16 from "../assests/sfd_bmd.png"
import pro17 from "../assests/Input.jpg"
// import pro18 from "../assests/unit.png"
import pro19 from "../assests/chat-bot.png"
import pro20 from "../assests/quiz.png"

const ProjectCardData = [

  {
    imgsrc: pro20,
    title: "Quiz Application",
    text: "Built a Multi-Exam Quiz App for students and professionals preparing for GATE, JEE, UPSC, GMAT, and Data Center exams. It offers timed quizzes, formula-based revisions, and performance analytics to improve accuracy and time management. Developed using Next.js with a JSON-based question bank, versioned on GitHub, and deployed on Vercel for optimized performance."
,
    view: "https://anirudh-sharma-quiz-app.vercel.app/",
  },


   {
    imgsrc: pro19,
    title: "AI - Chat_bot",
    text: "The UI of this was made using HTML , CSS , JavaScript and NLP's are used to make the conversations realistic. The project is deployed on the netlify",
    view: "https://anirudh-chat-bot.netlify.app/",
  },


  // {
  //   imgsrc: pro13,
  //   title:  "Food Delivery Website",
  //   text: "This website was made by using React JS and deployed at Vercel. From this the user can order food items at his/her location. It is not responsive now so kindly view it on laptop only.",
  //   view: "https://anirudh-foods.vercel.app/",
  // },
  
  {
    imgsrc: pro15,
    title: "Grocery Website",
    text: "This website was made by using React JS and deployed at Netlify. From this the user can order fruits, vegetables, etc. It is not responsive now so kindly view it on laptop only.",
    view: "https://anirudh-grocery.netlify.app/",
  },

  {
    imgsrc: pro16,
    title: "SFD and BMD Calculator",
    text: "Developed a web-based SFD & BMD Calculator using React (Frontend) and Python (Backend) to analyze and visualize shear force and bending moment distributions in beams.",
    view: "https://sfd-bmd-calculator.vercel.app/",
  },

  {
    imgsrc: pro17,
    title: "Converting Image into a pencil sketch using Python",
    text: "Developed a Python script to convert an image into a pencil sketch using OpenCV , sci-kit,  , turtle graphics, pillow, NumPy libraries",
    view: "https://drive.google.com/file/d/1-lPwDPdVbwfdMQMiuylTD8lEdK7jEqZC/view?usp=sharing",
  },

  {
    imgsrc: pro14,
    title: "Saloon Booking Website",
    text: "This website was made by using React JS and deployed at Vercel. From this the user can book appointments for his/her desired saloons and can access services. It is made responsive now so kindly view it on laptop and mobile devices.",
    view: "https://anirudh-saloons.vercel.app/",
  },

 
  
   {
    imgsrc: pro1,
    title: "DRDO Project-Intern",
    text: "Using Python, NumPy, and SciPy, I enhanced aerodynamic heating assessments for MIRVs at DRDL. And also improved efficiency and adaptability, and precision over earlier MATLAB code, and thoroughly studied the concepts of heat transfer and aerodynamics",
    view: "https://drive.google.com/file/d/17IOZHuCmrEWbY_7tBJClT5CRmzrJOS8T/view?usp=drive_link",
  },

  {
    imgsrc: pro2,
    title: "Mini Project at Indian Railways",
    text: "Explored various components of an IC Engine and studied them in a detailed manner.",
    view: "https://drive.google.com/file/d/12_O2m0lteulBwN2pQ9gW2FB0PTJBDkBW/view?usp=drive_link",
  },

  // {
  //   imgsrc: pro18,
  //   title: "Engineering Unit Converter",
  //   text: "Developed a responsive web-based Engineering Unit Converter using React JS for accurate, real-time conversions of length, area, volume, temperature, pressure, and mass. Designed to assist mechanical engineering students in simplifying design tasks, lab work, and academic projects by minimizing manual errors and saving time.",
  //   view: "https://jntuh-mechanical.vercel.app/",
  // },

  

  
  
  // {
  //   imgsrc: pro4,
  //   title: "JNTUH Coding Club",
  //   text: "Participated as an active member in the club and completed tasks,assignments on 6-week Python Training.",
  //   view: "https://drive.google.com/file/d/17SQ1TaLPIcrCRBXpkYgrWEKUNRkeNKgy/view?usp=drive_link",
  // },
  // {
  //   imgsrc: pro10,
  //   title: "Web Development",
  //   text: "Learnt concepts of Web Development and completed 7-day bootcamp.",
  //   view: "https://drive.google.com/file/d/14Ei9o4zVuA-eWHxZHAkA5G8gdOFJHHm3/view?usp=drive_link",
  // },
  // {
  //   imgsrc: pro6,
  //   title: "IITH Python",
  //   text: "Attended one month Python Training and completed various tasks.",
  //   view: "https://drive.google.com/file/d/1zCLTHA7ribBK-XaJx2b2PiYIXobwZbq-/view?usp=drive_link",
  // },
  // {
  //   imgsrc: pro5,
  //   title: "MATLAB",
  //   text: "Learnt basics of Matlab and simulation from Math-works.",
  //   view: "https://drive.google.com/file/d/1krbKZ26mWBU7nYUiEjfdREKC2oPat_fX/view?usp=drive_link",
  // },
  
  // {
  //   imgsrc: pro7,
  //   title: "JAVA",
  //   text: "Learnt JAVA programming concepts from INFOSYS Springboard.",
  //   view: "https://drive.google.com/file/d/1guAb48iY6mvFXSY3iYVC0zPgfi1TKIoo/view?usp=drive_link",
  // },

  
  // {
  //   imgsrc: pro3,
  //   title: "IIT Hyderabad Workshop",
  //   text: "Attended 2-day national workshop on the topic Automobiles and IC engines , learnt desembling and assesmbling of parts.",
  //   view: "https://drive.google.com/file/d/18J2t_QYb59IvN4kXtnyB9-6HuDa4vLm8/view?usp=drive_link",
  // },

  // {
  //   imgsrc: pro8,
  //   title: "Intellectual Property Rights",
  //   text: "Participated in IPR training program under National Intellectual Property awareness mission.",
  //   view: "https://drive.google.com/file/d/1atB6eHzCtO3zyZH1w4LpoKO7HotiWWrt/view?usp=drive_link",
  // },

  // {
  //   imgsrc: pro9,
  //   title: "3D printing",
  //   text: "Attended a 2-day national workshop at VNR college.",
  //   view: "https://drive.google.com/file/d/1rIbdxigbhkbj9-nM-1pbnAUlPqrXFWFz/view?usp=drive_link",
  // },

  
 

  // {
  //   imgsrc: pro12,
  //   title: "Chess League",
  //   text: "I have been playing chess since i was in school and secured 2nd position in a university level chess competition.",
  //   view: "https://drive.google.com/file/d/1dhEWpaRlkFsAkHncRMPCNvT06NZOaN1O/view?usp=drive_link",
  // },
  
  
];
export default ProjectCardData;
